import React from 'react'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useStoreState } from 'easy-peasy'

const LoadingModal = ({ size, show, message = "Loading...", backdrop = "static" }) => {
  const setting = useStoreState((state) => state.siteSettingsModel);

  return (
    <Modal
      size={size}
      show={show}
      backdrop={backdrop}
      centered
    >
      <Modal.Body className="text-center">
        <FontAwesomeIcon
          icon={faSpinner}
          spin
          size="3x"
          style={{
            color: setting.mainSettings.Flow.toUpperCase() === "ACTIVATION_PAYMENT"
              ? setting.brandSettings.BannerBgColor
              : "#888"
          }}
        />
        <div>
          <h5>{message}</h5>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default LoadingModal